/* eslint-disable no-use-before-define */
/* eslint-disable no-return-await */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { AnalyticsConfig } from '@carvana/purchase-store';
import { tracker } from '@carvana/analytics';
import { DashboardModalActions } from '@carvana/purchase-helpers';
import { CarvanaButton } from '@carvana/purchase-styles';
import * as SchedulerActions from '../../ducks/actions';
import DeliveryMethodAddress from './components/delivery-method-address';
import DateTimepicker from './components/date-time-picker';
import * as sc from './rescheduler-modal.styles';

const ReschedulerModal = props => {
  const {
    marketing,
    orderSummary: {
      vehicle: { vehicleId, make, model, year, price, stockNumber },
      trade: { declined },
      quote: { totalPrice },
      paymentMethod: { method, institutionName },
      schedule: { deliveryPreference },
      schedule
    },
    customerIsGreen,
    rescheduleModal: { schedulerIsLoaded, selectedTimeSlot },
    rescheduleModal,
    isContractToCRPhase2
  } = props;

  const {
    FetchOrderSummary,
    FetchOrderOptions,
    GetTransferScheduleTimeslots,
    SubmitSelectedTimeSlot
  } = SchedulerActions;

  const dispatch = useDispatch();

  const isDelivery = deliveryPreference?.toLowerCase()?.includes('delivery');
  const deliveryType = isDelivery ? 'delivery' : 'pick-up';

  const selectNewTimeSlot = () => {
    DashboardModalActions.ShowModalLoadingSpinner();
    SubmitSelectedTimeSlot(selectedTimeSlot)
      .then(async () => FetchOrderOptions() && (await FetchOrderSummary()))
      .finally(() => DashboardModalActions.CloseModal());
  };

  const trackSchedulingEvent = () => {
    const gtm = {
      vehicleId,
      vehicleMake: make,
      vehicleModel: model,
      vehicleYear: year,
      vehiclePrice: price,
      stockNumber,
      paymentMethod: method,
      financingInstitutionName: institutionName,
      totalDealPrice: totalPrice,
      tradeAttached: !declined,
      ...marketing
    };

    const track = tracker(AnalyticsConfig);
    track(
      'trackEvent',
      'Scheduling Transfer',
      {
        gtm
      },
      ['gtm']
    );
  };

  useEffect(() => {
    if (!schedulerIsLoaded) {
      dispatch(GetTransferScheduleTimeslots()).then(() =>
        DashboardModalActions.HideModalLoadingSpinner()
      );
    } else {
      trackSchedulingEvent();
    }
  }, []);

  return (
    <sc.Container>
      <sc.HeaderContainer>
        <sc.HeaderTextBold>Choose your {deliveryType} time</sc.HeaderTextBold>
        {(customerIsGreen && isContractToCRPhase2) || (!isContractToCRPhase2)
          ? (
            <sc.HeaderText>
              Your {deliveryType} can be rescheduled no later than 24 hours before
              your currently scheduled date. You will need to re-sign your contracts
              reflecting the change.
            </sc.HeaderText>
          )
          : (
            <sc.HeaderText>
              Your {deliveryType} can be rescheduled no later than 24 hours before
              your currently scheduled date.
            </sc.HeaderText>
          )
        }
      </sc.HeaderContainer>
      <sc.BodyContainer>
        <sc.AddressContainer>
          <DeliveryMethodAddress schedule={schedule} />
        </sc.AddressContainer>
        {schedulerIsLoaded && <DateTimepicker rescheduleModal={rescheduleModal}/>}
        <sc.ButtonWrapper>
          <CarvanaButton
            disabled={!selectedTimeSlot.optionId}
            onClick={selectNewTimeSlot}
          >
            Submit and continue
          </CarvanaButton>
        </sc.ButtonWrapper>
      </sc.BodyContainer>
    </sc.Container>
  );
};

ReschedulerModal.propTypes = {
  marketing: PropTypes.shape({}).isRequired,
  orderSummary: PropTypes.shape({}).isRequired,
  rescheduleModal: PropTypes.shape({}).isRequired
};

ReschedulerModal.defaultProps = {};

export default ReschedulerModal;
